// Guest ID / quota helpers — 3 free scans per browser.

const GUEST_ID_KEY = "guest_id";
const GUEST_COUNT_KEY = "guest_scan_count";

export function getGuestId() {
  let id = localStorage.getItem(GUEST_ID_KEY);
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `g-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(GUEST_ID_KEY, id);
  }
  return id;
}

export function getGuestScanCount() {
  return parseInt(localStorage.getItem(GUEST_COUNT_KEY) || "0", 10);
}

export function setGuestScanCount(n) {
  localStorage.setItem(GUEST_COUNT_KEY, String(n));
}
